import { Button } from "@growtherapy/sprout-ui";
import { useVisitorConnectRoomCallback } from "./admission/useVisitorConnectRoomCallback";
import { useAdmissionTrackingEvents } from "./admission/useAdmissionTrackingEvents";
import { useAtomValue } from "jotai";
import { VisitorState, visitorStateAtom } from "../state";

export function JoinSessionButton({
  onJoin: handleJoin,
  isLoading,
}: {
  onJoin: () => void;
  isLoading: boolean;
}) {
  return (
    <Button
      use="primary"
      size="md"
      className="w-full"
      onClick={handleJoin}
      loading={isLoading}
    >
      Join session
    </Button>
  );
}

export function JoinSessionButtonWrapper() {
  const connectRoom = useVisitorConnectRoomCallback();
  const isLoading = useAtomValue(visitorStateAtom) === VisitorState.JOINING;
  const { trackJoinSessionClicked } = useAdmissionTrackingEvents();

  return (
    <JoinSessionButton
      onJoin={() => {
        connectRoom();
        trackJoinSessionClicked();
      }}
      isLoading={isLoading}
    />
  );
}
